export default "__VITE_ASSET__yenMc3tf__"